import React from "react";
import { useSelector } from "react-redux";
import { Space, Typography, Button, Table } from "antd";
import { useIntl } from "react-intl";
import { RightOutlined, LeftOutlined } from "@ant-design/icons";

import styles from "./index.module.scss";

import { Link } from "react-router-dom";
import { RouterEnum } from "../../../enums/RouterEnum";

export default function OnDemandStatus(props) {
  const theme = useSelector((state) => state.userSettings.theme);
  const intl = useIntl();

  const columns = [
    {
      title: intl.formatMessage({ id: "global.presentation.value" }),
      dataIndex: "value",
      width: "50%",
    },
    {
      title: intl.formatMessage({ id: "global.presentation.description" }),
      dataIndex: "description",
      width: "50%",
    },
  ];

  const data = [
    {
      value: "Created",
      description: intl.formatMessage({ id: "global.presentation.created" }),
    },
    {
      value: "WaitingForConfirmation",
      description: intl.formatMessage({
        id: "global.presentation.waitingForConfirmation",
      }),
    },
    {
      value: "InProgress",
      description: intl.formatMessage({ id: "global.presentation.inProgress" }),
    },
    {
      value: "Completed",
      description: intl.formatMessage({ id: "global.presentation.completed" }),
    },
    {
      value: "ManualAttentionRequired",
      description: intl.formatMessage({
        id: "global.presentation.manualAttentionRequired",
      }),
    },
    {
      value: "Invalid",
      description: intl.formatMessage({ id: "global.presentation.invalid" }),
    },
    {
      value: "Canceled",
      description: intl.formatMessage({ id: "global.presentation.canceled" }),
    },
    {
      value: "Timeouted",
      description: intl.formatMessage({ id: "global.presentation.timeouted" }),
    },
    {
      value: "Error",
      description: intl.formatMessage({ id: "global.presentation.error" }),
    },
  ];

  return (
    <div
      className={[
        styles.main,
        theme === "dark" ? styles["dark-mode"] : "",
      ].join(" ")}
    >
      <div className={styles.section}>
        <Space direction="vertical">
          <div>
            <Typography.Title level={2}>OnDemand status</Typography.Title>
          </div>
        </Space>
      </div>
      <div className={styles.section}>
        <Space direction="vertical" className={styles["full-width"]}>
          <div className={styles["api-section"]}>
            <div className={styles.object}>
              <div className={styles.table}>
                <Table
                  columns={columns}
                  dataSource={data}
                  bordered
                  pagination={false}
                  rowKey={"name"}
                  scroll={{ x: 'max-content' }}
                />
              </div>
            </div>
          </div>
        </Space>
      </div>
      <div className={styles.section}>
        <Space direction="horizontal">
          <Link to={RouterEnum.VoidCompletionType.Path}>
            <Button type="primary">
              <LeftOutlined />
              {intl.formatMessage({ id: "global.presentation.previous" })}
            </Button>
          </Link>
        </Space>
      </div>
    </div>
  );
}
